class GartnerPi_Aria {
  constructor({ targetSelector, subtreeReadyIndicator }) {
    this.targetSelector = targetSelector
    this.subtreeReadyIndicator = subtreeReadyIndicator
    this.observeDOMChanges()
    // this.waitForElementToDisplay(`${this.targetSelector} ${this.subtreeReadyIndicator}`, 250, 40)
  }
  waitForElementToDisplay(selector, time, maxAttempts) {
    if (document.querySelector(selector) != null) {
      this.observeDOMChanges()
      return
    } else if (maxAttempts <= 0) {
      console.error("Maximum attempts reached. Element not found:", selector)
      return
    } else {
      setTimeout(() => {
        this.waitForElementToDisplay(selector, time, maxAttempts - 1)
        console.log("tick")
      }, time)
    }
  }

  observeDOMChanges() {
    const targetNode = document.querySelector(this.targetSelector)
    if (!targetNode) {
      console.error("Target node for observing not found:", this.targetSelector)
      return
    }

    const config = { childList: true, subtree: true }

    const observer = new MutationObserver((mutations, obs) => {
      const gartnerPiWidgetWithSubtree = document.querySelector(
        `[id^="gartner-pi-widget"] ${this.subtreeReadyIndicator}`,
      )
      if (gartnerPiWidgetWithSubtree) {
        const gartnerPiWidget = document.querySelector(`[id^="gartner-pi-widget"]`)
        this.initStarsAriaLabels(gartnerPiWidget)
      }
    })

    observer.observe(targetNode, config)
  }

  initStarsAriaLabels(widget) {
    // Select all star rating elements within the widget
    const starRatings = widget.querySelectorAll(".gartner-pi-star-rating")
    starRatings.forEach((rating) => {
      // Get all the score spans within this rating
      const scoreSpans = rating.querySelectorAll(".gartner-pi-star-rating-score")
      scoreSpans.forEach((scoreSpan) => {
        const width = scoreSpan.style.width

        // Calculate the star rating based on the width
        const ratingValue = parseFloat(width) / 20 // Each star represents 20%
        const roundedRating = Math.round(ratingValue * 10) / 10 // Round to one decimal place

        // Set the aria-label attribute for each score span
        scoreSpan.parentNode.setAttribute("aria-label", `Star rating: ${roundedRating} out of 5`)
      })
    })
  }
}

export { GartnerPi_Aria }
